// 两个前端的项目管理均依据服务端资源动作；旧菜单调用保留兼容映射。
const projectMenus = ['kydz/View/Data', 'kydz/View/Scada']
const projectActions = { query: 'query', add: 'save', delete: 'delete', publish: 'publish' }
const resourceAllowed = (state, rootGetters, resourceId, action) =>
  state.resourcePermissionsLoaded && (rootGetters['user/isAdmin'] || !!state.resourcePermissions[resourceId]?.includes(action))

const state = {
    permissions: {},
    resourcePermissions: {},
    resourcePermissionsLoaded: false
  };
  
  const mutations = {
    SET_PERMISSIONS(state, { code, buttons }) {
        state.permissions[code] = buttons;
    },
    CLEAR_MENU_PERMISSIONS(state) {
        state.permissions = {}
    },
    CLEAR_RESOURCE_PERMISSIONS(state) {
        state.resourcePermissions = {}
        state.resourcePermissionsLoaded = false
    },
    SET_RESOURCE_PERMISSIONS(state, permissions) {
        state.resourcePermissions = permissions
        state.resourcePermissionsLoaded = true
    },
    CLEAR_PERMISSIONS(state) {
        state.permissions = {}
        state.resourcePermissions = {}
        state.resourcePermissionsLoaded = false
    }
  };
  
  const actions = {
    savePermissions({ commit }, data) {
      // 同步时替换菜单，已被撤销的旧按钮不能残留。
      commit('CLEAR_MENU_PERMISSIONS')
      handleAuthMenu(data, commit)
    },
    saveResourcePermissions({ commit }, data) {
      // 解析失败也收回旧快照，不能继续沿用上次的写入授权。
      commit('CLEAR_RESOURCE_PERMISSIONS')
      if (!data || !Array.isArray(data.permissions)) throw new Error('资源权限读取失败，请重试')
      const permissions = {}
      data.permissions.forEach(permission => {
        if (!permission || typeof permission.id !== 'string' || !permission.id || !Array.isArray(permission.actions) || permission.actions.some(action => typeof action !== 'string')) {
          throw new Error('资源权限读取失败，请重试')
        }
        permissions[permission.id] = Array.from(new Set([...(permissions[permission.id] || []), ...permission.actions]))
      })
      commit('SET_RESOURCE_PERMISSIONS', permissions)
    },
    clearPermissions({ commit }) {
      commit('CLEAR_PERMISSIONS');
    }
  };
  
  const getters = {
    permissions: state => state.permissions,
    resourcePermissionsLoaded: state => state.resourcePermissionsLoaded,
    hasResourcePermission: (state, getters, rootState, rootGetters) => code => {
      const [resourceId, action] = code.split(':')
      return resourceAllowed(state, rootGetters, resourceId, action)
    },
    isAuth: (state, getters, rootState, rootGetters) => (code) => {
      const codes = Array.isArray(code) ? code : [code]
      return codes.some((key) => {
        const [menuCode, button] = key.split(':')
        if (projectMenus.includes(menuCode)) {
          const action = projectActions[button]
          return !!action && resourceAllowed(state, rootGetters, 'visualization', 'query') && resourceAllowed(state, rootGetters, 'visualization', action)
        }
        return !!state.permissions[menuCode]?.includes(button)
      })
    }
  };

  function handleAuthMenu(list, commit) {
    list.forEach(item => {
      const { code, buttons, children } = item
  
      if (buttons && code) {
        commit('SET_PERMISSIONS', {
          code,
          buttons: buttons.map(b => b.id)
        })
      }
  
      if (children && children.length) {
        handleAuthMenu(children, commit)
      }
    })
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
  